import React from 'react';
import { NavLink } from 'react-router-dom';
import Button from "../elements/buttons/Button";
const Navbar = () =>(
    <>         
            
    <nav className="navbar">
        <ul>
            <li><NavLink exact activeClassName="active" to="/canales">Canales</NavLink></li>
            <li><NavLink activeClassName="active" to="/guia">Guía</NavLink></li>
            <li><NavLink activeClassName="active" to="/cartelera">Cartelera</NavLink></li>
            <li><NavLink activeClassName="active" to="/planes">Planes</NavLink></li>
            <li><NavLink activeClassName="active" to="/dispositivos">Dispositivos</NavLink></li>
            <li><NavLink activeClassName="active" to="/ayuda">Ayuda</NavLink></li>
        </ul>
        <div className="featuredButtons">
            <Button copy="Iniciar sesión" link="/" className="button-gradient" />
            <Button copy="Suscríbete" link="/" className="button-primary" />
        </div>

    </nav>
    </>
)

export default Navbar;